import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useDispatch, useSelector } from 'react-redux';
import { getTemplateDetails } from '../../templates-selector';
import { List, Typography, Button, Checkbox } from 'antd';
import { saveSelectedHOO } from '../../templates-actions';
const { Title } = Typography;

export const HooChoices = ({
  overrideCloneName: overrideProp,
  onOverrideChange,
}: {
  overrideCloneName?: boolean;
  onOverrideChange?: (v: boolean) => void;
}) => {
  const dispatch = useDispatch();
  const details = useSelector(getTemplateDetails);
  const originalTemp = details?.timeRange;
  const [selectedItems, setSelectedItems] = useState<string[]>([]);
  // Support either controlled override prop from parent or local state
  const [overrideCloneName, setOverrideCloneName] = useState<boolean>(!!overrideProp);

  const toggleSelect = (item: string) => {
    if (item !== originalTemp)
      setSelectedItems(
        (prev) =>
          prev.includes(item)
            ? prev.filter((i) => i !== item) // Deselect
            : [...prev, item] // Select
      );
  };

  useEffect(() => {
    dispatch(saveSelectedHOO(selectedItems));
  }, [selectedItems]);

  useEffect(() => {
    // if parent provides a controlled prop, keep local state in sync
    if (typeof overrideProp === 'boolean') setOverrideCloneName(overrideProp);
  }, [overrideProp]);

  return (
    <StyledPanel>
      <StiledExamsLine>
        <StyledHeader>
          <Title level={5} style={{ marginRight: 12 }}>
            HOO Clones
          </Title>
          <div style={{ display: 'flex', gap: 8, marginLeft: 'auto' }}>
            <Button
              size='small'
              onClick={() => {
                if (!details?.HooChoices) return;
                const all = Object.values(details.HooChoices).filter((v) => v !== originalTemp);
                setSelectedItems(all as string[]);
              }}
            >
              Select ALL
            </Button>
            <Button
              size='small'
              onClick={() => {
                setSelectedItems([]);
              }}
            >
              Clear ALL
            </Button>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              <Checkbox
                checked={overrideCloneName}
                onChange={(e) => {
                  const v = e.target.checked;
                  // notify parent if handler provided, else update local state
                  if (onOverrideChange) onOverrideChange(v);
                  else setOverrideCloneName(v);
                }}
              >
                Override Clone Name
              </Checkbox>
            </div>
          </div>
        </StyledHeader>
        {details?.HooChoices && (
          <StyledList>
            <List
              dataSource={Object.values(details.HooChoices)}
              renderItem={(item: any) => {
                const isOriginal = originalTemp === item;
                const isSelected = selectedItems.includes(item);
                return (
                  <List.Item
                    onClick={() => toggleSelect(item)}
                    style={{
                      backgroundColor: isOriginal ? '#d9d9d9' : isSelected ? '#bcf5f5ff' : 'white',
                      cursor: 'pointer',
                    }}
                  >
                    {String(item)}
                  </List.Item>
                );
              }}
            />
          </StyledList>
        )}
      </StiledExamsLine>
    </StyledPanel>
  );
};

const StyledPanel = styled.div`
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
  padding: 40px 20px 0;
  border-top: 1px solid rgb(186, 210, 227);
`;

const StiledExamsLine = styled.div`
  display: flow;
  margin-bottom: 35px;
  flex-wrap: wrap;
`;

const StyledHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 20px;
`;

const StyledList = styled.div`
  height: 200px;
  width: 200px;
  overflow-y: auto;
  border: 5px solid rgb(186, 210, 227);
  padding: 0 10px 0;
`;
